<template>
  <!-- <div class="box">
    <div class="left">
      <div class="box-left">主体认证
        <span class="box-left-span" v-show="list.count&&list.count>0"> {{list.count}}</span>
        <img class="box-right-img" v-show="!list.count || list.count==0" src="../img/complete.png" alt="">
      </div>
      <div :class="list.count?'box-abled':'box-disabled'" @click="examine">去审核</div>
    </div>
    <div class="box-centre"></div>
    <div class="right">
      <div class="box-right">示范社申请
        <span class="box-left-span" v-show="list.demoCount&&list.demoCount>0"> {{list.demoCount}}</span>
        <img class="box-right-img" v-show="!list.demoCount || list.demoCount==0" src="../img/complete.png" alt="">
      </div>
      <div :class="list.demoCount?'box-abled':'box-disabled'" @click="demonstration">去审核</div>
    </div>
  </div> -->
  <div class="wrap">
    <div class="item">
      <div class="item_1 blue">
        <div class="item_data">
          <span class="value">{{list.count}}<span class="unit">个</span></span>
        </div>
        <div class="item_content" style="left: 22px;">
          <span class="title">主体认证</span>
        </div>
      </div>
      <i class="el-icon-s-check icon-static" @click="examine"></i>
    </div>
    <div class="item">
      <div class="item_1 green">
        <div class="item_data">
          <span class="value">{{list.demoCount}}<span class="unit">个</span></span>
        </div>
        <div class="item_content">
          <span class="title">示范社请求</span>
        </div>
      </div>
      <i class="el-icon-s-check icon-static" @click="demonstration"></i>
    </div>
    <div class="item">
      <div class="item_1 yellow">
        <div class="item_data">
          <span class="value">{{configCount}}<span class="unit">个</span></span>
        </div>
        <div class="item_content">
          <span class="title">项目申请</span>
        </div>
      </div>
      <i class="el-icon-s-check icon-static" @click="configGo"></i>
    </div>

  </div>
</template>

<script>
import Cookies from "js-cookie"
import API from "@/api/serviceOrgManagement/api_userManagement";
import API_CONFIG from "@/api/api_project/api_project";
export default {
  data() {
    return {
      list:[],
      qhdm: Cookies.get('areacode'),
      status: '',
      configCount: 0,
      countStatus: ''
    }
  },
   created() {
     this.chooseRoleCode()
     this.GLOBAL.eventBus.$on("refresh_big_screen_info",this.queryData);
   },
  methods: {
    chooseRoleCode() {
      let roleList = localStorage.getItem('roleList')

      if(roleList) {
        roleList = JSON.parse(roleList)
        // 名录库主体审核是乡镇初审，县级复审
        // 项目管理是县级初审，市级复审

        // 正式环境角色名：社会化乡镇管理员，社会化市级管理员，社会化县级管理员
        // 测试环境角色名：乡镇管理员，市级管理员，县级管理员
        console.log('process.env.xiangzhen_manger', process.env.xiangzhen_manger)

        roleList.forEach(item => {
          console.log('item', item.roleCode)
          if(item.roleCode == process.env.shij_manger) {
            this.status = 4
            this.countStatus = ''
          } else if(item.roleCode== process.env.xianj_manger){
            this.countStatus = 8
            this.status = 3
          } else if (item.roleCode == process.env.xiangzhen_manger) {
            this.status = ''
            this.countStatus = 4
          } else {
            this.status = ''
            this.countStatus = ''
          }

          console.log('count', this.countStatus)
        });
      }

      setTimeout(() => {
        this.confitCount()
        this.enterpriseStatWaitCount();
      }, 50);

    },
    queryData(qhdm){
      this.qhdm = qhdm;
    },
    async enterpriseStatWaitCount() {
      const { code, data } = await API.enterpriseStatWaitCount({qhdm:this.qhdm, status: this.countStatus});
      console.log("data",data)
      if (code === 0) {
        this.list = data;
        // console.log("this.list",this.list)
      }
    },
    async confitCount() {
      const { code, data } = await API_CONFIG.getRecordNumber({
        qhdm: this.qhdm,
        status: this.status
      });

      if (code === 0) {
        this.configCount = data.count;
        // console.log("this.list",this.list)
      }
    },
    examine(){
      if(!this.list.count) return
      this.$router.push({
        path:'/subject/libraryListReviewed',
        query: {
          mode: 'unaudited'
        }
      })
    },
    configGo() {
      if(!this.configCount) return
      this.$router.push({
        path:'/project/manage',
        query: {
          mode: 'unaudited'
        }
      })
    },
    demonstration(){
      if(!this.list.demoCount) return
      this.$router.push({
        path:'/demonstration/Administration',
        query: {
          mode: 'unaudited'
        }
      })
    }
    }
};
</script>

<style lang="less" scoped>

.wrap {
  height: calc(100% - 40px);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  .item {
    width: calc(50% - 5px);
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content:center;
    align-items: center;

    .icon-static {
      font-size: 24px;
      color: #CEF2FF;
      cursor: pointer;

      &:hover {
        color: #00D7FE;
      }
    }

    .item_1 {
      height: 80%;
      width: 110px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      text-align: center;
      position: relative;

      .item_content {
        position: absolute;
        top: 18px;
        left: 16px;
      }
      .item_data {
        position: absolute;
        top: -7px;
        left: 39px;
      }
      .value {
        color: #00D7FE;
        font-size: 20px;
        font-weight: bold;
      }
      .unit {
        color: #00D7FE;
        font-size: 14px;
        font-weight: 400;
      }
      .title {
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }
}

.blue {
  background-image: url("../../../../static/img/l1bg1.png");
}

.yellow {
  background-image: url("../../../../static/img/l1bg1.png");
}

.green {
  background-image: url("../../../../static/img/l1bg2.png");
}

</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/homelefttop.vue